module.exports = __webpack_public_path__ + "staticfr/media/Exposifr.359d20d7.png";